import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import auth, { AUTH_SET } from "./modules/auth";
import categories from "./modules/categories";
import nav from "./modules/nav";
import ui from "Shared/store/ui";
import settings, { SETTINGS_SET } from "./modules/settings";
import permissions, { PERMISSIONS_SET } from "Public/store/modules/permissions";
import columnPresets, {
  COLUMN_PRESET_ACTIVE_ID_SET,
} from "Public/store/modules/columnPresets";
import { parseInitPermissions } from "Public/store/utils/parseInitPermissions";
import { parseInitSettings } from "Public/store/utils/parseInitSettings";
import { isPublicUrl } from "Shared/utils/isPublicUrl";
import { ExplorerColumnPresetType } from "Modules/explorers/types/ExplorerColumnPresetType";
import { explorerColumnDefaultPresetsByType } from "Modules/explorers/constants/explorerColumnDefaultPresetsByType";

Vue.use(Vuex);

export const INIT = "init";
const actions = {
  [INIT]: ({ commit }) => {
    if (!isPublicUrl() && !window.location.href.includes("-public")) {
      return axios
        .get("/api/init")
        .then(({ data }) => {
          commit(AUTH_SET, data);
          const permissions = parseInitPermissions(data);
          commit(PERMISSIONS_SET, permissions);
          const settings = parseInitSettings(data);
          commit(SETTINGS_SET, settings);
          commit(COLUMN_PRESET_ACTIVE_ID_SET, {
            type: ExplorerColumnPresetType.users,
            id: data.user?.usersExplorerPreset
              ? data.user.usersExplorerPreset
              : explorerColumnDefaultPresetsByType[
                  ExplorerColumnPresetType.users
                ].id,
          });
          commit(COLUMN_PRESET_ACTIVE_ID_SET, {
            type: ExplorerColumnPresetType.groups,
            id: data.user?.groupsExplorerPreset
              ? data.user.groupExplorerPreset
              : explorerColumnDefaultPresetsByType[
                  ExplorerColumnPresetType.groups
                ].id,
          });
          commit(COLUMN_PRESET_ACTIVE_ID_SET, {
            type: ExplorerColumnPresetType.library,
            id: data.user?.libraryExplorerPreset
              ? data.user?.libraryExplorerPreset
              : explorerColumnDefaultPresetsByType[
                  ExplorerColumnPresetType.library
                ].id,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
};

export default new Vuex.Store({
  actions: actions,

  modules: {
    ui,
    auth,
    categories,
    nav,
    permissions,
    settings,
    columnPresets,
  },
});
